/**
 * A file's date, in the order the sources deserve to be believed.
 *
 *   addedAt       what the document brought with it. A referral filed in March
 *                 2025 and migrated today is a March 2025 document.
 *   lastModified  what S3 says about the object. Free on every listing, and the
 *                 truth for anything uploaded here, including after a replace.
 *   the file name last, and only for keys written before either existed.
 *
 * The patient portal draws the same files as the clinic app and must not tell a
 * different story about them. The last source is an address being read as a
 * record: an epoch baked into the key at upload and parsed back out by
 * splitting on hyphens. It works only for names this system wrote, which is why
 * a migrated document showed the patient no date at all.
 */
const asDate = (value) => {
  if (!value) return null;
  const at = new Date(value);
  return Number.isNaN(at.getTime()) ? null : at;
};

export const fileDate = (addedAt, lastModified, fileName) => {
  const at = asDate(addedAt) || asDate(lastModified);
  if (at) return at.toLocaleDateString("en-US");
  return extractFileName(fileName || "", "modified");
};

export const fileDateTime = (addedAt, lastModified, fileName) => {
  const at = asDate(addedAt) || asDate(lastModified);
  if (at) return at.toLocaleString("en-US");
  return extractFileDateTime(fileName || "");
};

/** A size S3 measured, rather than one written into the name at upload. */
export const fileSize = (bytes, fileName) => {
  const n = Number(bytes);
  if (Number.isFinite(n) && n > 0) {
    if (n < 1024) return `${n} B`;
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
    return `${(n / 1024 / 1024).toFixed(1)} MB`;
  }
  return extractFileName(fileName || "", "size");
};

export const extractFileName = (fileName, property) => {
  if (property === 'name') {
    if (fileName.split("-")[0]?.slice(0, 6) === "prefix") {
      const secondHyphenIndex = fileName.indexOf('-', fileName.indexOf('-') + 1);
      let name = fileName.slice(secondHyphenIndex + 1).split('_(');
      
      if (name.length > 1) {
          const extension = (fileName.match(/\.[^.]+$/) || [])[0] || "";
          return `${name[0]}${extension}`;
      }
      return name[0]
    }
    return fileName;
  }
  if (property === 'size') {
    if (fileName.split("-")[0]?.slice(0, 6) === "prefix") return parseInt(fileName.split("-")[1]) + " Kib"
  }

  if (property === 'modified') {
    if (fileName.split("-")[0]?.slice(0, 6) === "prefix") return new Date(parseInt(fileName.split("-")[0].split("_")[1])).toLocaleDateString("en-US")
  }
}

export const extractFileDateTime = (fileName) => {
  if (fileName.split("-")[0]?.slice(0, 6) === "prefix") return new Date(parseInt(fileName.split("-")[0].split("_")[1])).toLocaleString("en-US")
}
